var Event = require("cocos/framework/components/event")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
require("clover/panel/component/common/UIButton")
let { needHideRewardNum } = require("./MarkViewUtil")
var MarkItemEvent = table(
    [1, "ClickMark", "MARKITEMEVENT.CLICKMARK"],
    [1, "ClickRemark", "MARKITEMEVENT.CLICKREMARK"],
    [1, "TimeLimit", "MARKETGIFTBAGNODE.TIMELIMIT"],
)
/**
 * 签到面板中签到条目
 */
MarkItem = xClass("MarkItem", Event, function () {
    return cc.CSLoader.createNode("cocos/mark_panel_3_mark_item.csb")
})
MarkItem.prototype.ctor = function (config) {
    var self = this

    self.config = config || {}
    self.bind(self)
    self.init()
}
MarkItem.prototype.init = function () { 
    var self = this

    //  天数
    self.day = self.getChildByName("txt_day")
    self.day.setFontWeight("bold")
    self.day.getVirtualRenderer().setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    self.day.getVirtualRenderer().setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER)
    self.day.y -= 2
    if (self.config.isToday) {
        self.day.setString("今天")
        self.day.setColor(cc.color(185, 107, 75, 255))
    } else {
        self.day.setString("第" + self.config.day + "天")
    }

    //  特效
    self.effect = self.getChildByName("effect")
    if (self.config.isToday) {
        self.effect.setVisible(true)
        self.effect.setScale(2)
        self.effectAnim = cc.CSLoader.createTimeline("cocos/mark_panel_3_stargolow000all.csb");
        self.effect.runAction(self.effectAnim)
        self.effectAnim.gotoFrameAndPlay(0, true);
    } else {
        self.effect.setVisible(false)
    }

    //  签到奖励
    self.reward_single = self.getChildByName("reward_single")
    self.reward_single.setScale(1.12)
    if (self.config.mark_reward.length == 0) {
        //  没有奖励，肯定是配置错了，那也什么都不显示
        self.reward_single.setVisible(false)
    } else if (self.config.mark_reward.length >= 1) {
        //  单个奖励，目前来说是正常配置
        var reward = self.config.mark_reward[0].split(':')
        //  物品图标
        var propMeta = MetaManager.getInstance().getPropMeta(reward[0])
        var icon = self.reward_single.getChildByName("icon")
        var num = self.reward_single.getChildByName("num")
        if (propMeta && propMeta.expireTime !== 0) {
            propIcon = UIItemBuilder.createPropIcon(reward[0], (Localhost.time() + propMeta.expireTime))
            //propIcon.setPosition(icon.getPostion)
            propIcon.x = icon.x
            propIcon.y = icon.y
            propIcon.setAnchorPoint(icon.getAnchorPoint())
            propIcon.setName(icon.getName())
            propIcon.setScale(icon.getScale())
            icon.removeFromParent(true)
            self.reward_single.addChild(propIcon)
            num.setLocalZOrder(propIcon.getLocalZOrder() + 1)
        } else {
            self.reward_single.getChildByName("icon").setSpriteFrame(UIItemBuilder.createPropIcon(reward[0]).getSpriteFrame())
        }
        num.setString(reward[1])
        num.setNextFontPositionXOffset(-4)
        //  如果奖励是货币，则需要调整一下数量位置
        if (MarkItem.rewardIsCurrency(reward[0])) {
            num.x -= 30
            num.y -= 7
        } else {
            num.x += 5
            num.y -= 7
        }
    }
}
/**
 * 检查奖励是否为货币
 * @param rewardId  奖励Id
 */
MarkItem.rewardIsCurrency = function (rewardId) {
    if (rewardId == GamePropIds.kCoin || rewardId == GamePropIds.kCash) {
        return true
    } else {
        return false
    }
}

module.exports = table([0, MarkItem], [0, MarkItemEvent])